(function () {
  'use strict';

  var VIEW_THRESHOLD = 0.5;
  var VISIBLE_MS_THRESHOLD = 500;
  var runtime = null;
  var runCounter = 0;

  function getAttribute(node, attributeName) {
    if (!node) {
      return '';
    }

    var value = node.getAttribute(attributeName);
    return value == null ? '' : value;
  }

  function toNumber(value, fallback) {
    var parsed = Number(value);
    if (Number.isFinite(parsed)) {
      return parsed;
    }

    return fallback;
  }

  function toNumberOrEmpty(value) {
    if (value === '' || value == null) {
      return '';
    }

    var parsed = Number(value);
    if (Number.isFinite(parsed)) {
      return parsed;
    }

    return '';
  }

  function createPageInstanceId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return String(Date.now()) + '-' + Math.random().toString(16).slice(2);
  }

  function capture(posthogInstance, eventName, properties) {
    if (!posthogInstance || typeof posthogInstance.capture !== 'function') {
      return;
    }

    posthogInstance.capture(eventName, properties);
  }

  function clearCardTimers(cardTimers) {
    cardTimers.forEach(function (timer) {
      clearTimeout(timer);
    });
    cardTimers.clear();
  }

  function cleanupRuntime() {
    if (!runtime) {
      return;
    }

    if (runtime.sectionTimer) {
      clearTimeout(runtime.sectionTimer);
      runtime.sectionTimer = null;
    }

    if (runtime.cardTimers) {
      clearCardTimers(runtime.cardTimers);
    }

    if (runtime.sectionObserver) {
      runtime.sectionObserver.disconnect();
      runtime.sectionObserver = null;
    }

    if (runtime.cardObserver) {
      runtime.cardObserver.disconnect();
      runtime.cardObserver = null;
    }

    runtime = null;
  }

  function isEligibleContext(context) {
    return !!context && context.page_type === 'index' && context.is_logged_in === true;
  }

  var utils = window.__JH_POSTHOG_UTILS__;
  if (!utils || typeof utils.waitForPostHogReady !== 'function') {
    return;
  }

  function initializeForPageInstance() {
    cleanupRuntime();

    var context = utils.getContext();
    if (!isEligibleContext(context)) {
      return;
    }

    var runId = runCounter + 1;
    runCounter = runId;
    runtime = {
      id: runId,
      sectionTimer: null,
      cardTimers: new Map(),
      sectionObserver: null,
      cardObserver: null
    };

    utils.waitForPostHogReady({ intervalMs: 100, timeoutMs: 8000 }).then(function (posthogInstance) {
      if (!runtime || runtime.id !== runId) {
        return;
      }

      if (!posthogInstance) {
        return;
      }

      if (typeof utils.hasOptedOut === 'function' && utils.hasOptedOut(posthogInstance)) {
        return;
      }

      var pageInstanceId = createPageInstanceId();
      var sectionMetricsNode = document.querySelector('[data-fy-section="1"]');

      if (!sectionMetricsNode) {
        capture(posthogInstance, 'fy_section_status', {
          fy_status: 'not_rendered',
          fy_metafield_blank: context.fy_metafield_blank === true,
          fy_raw_count: toNumber(context.fy_raw_count, 0),
          fy_rendered_count: 0,
          fy_set_id: context.fy_set_id || '',
          fy_version: toNumberOrEmpty(context.fy_version),
          fy_generated_at: context.fy_generated_at || '',
          fy_drop_missing_product_count: 0,
          fy_drop_no_matching_variant_count: 0,
          fy_drop_no_available_variant_count: 0,
          fy_page_instance_id: pageInstanceId,
          fy_section_id: '',
          fy_not_rendered_reason:
            context.fy_metafield_blank === true ? 'blank_recommendations' : 'section_missing_from_dom'
        });
        return;
      }

      var sectionId = getAttribute(sectionMetricsNode, 'data-fy-section-id');
      var sectionViewNode = null;

      if (sectionId !== '') {
        sectionViewNode = document.getElementById('shopify-section-' + sectionId);
      }

      if (!sectionViewNode) {
        sectionViewNode = sectionMetricsNode.closest('section.shopify-section, .shopify-section');
      }

      if (!sectionViewNode) {
        sectionViewNode = sectionMetricsNode.parentElement || sectionMetricsNode;
      }

      var sectionSetId = getAttribute(sectionMetricsNode, 'data-fy-set-id') || (context.fy_set_id || '');
      var sectionVersionRaw = getAttribute(sectionMetricsNode, 'data-fy-version');
      var sectionGeneratedAt =
        getAttribute(sectionMetricsNode, 'data-fy-generated-at') || (context.fy_generated_at || '');
      var sectionRawCount = toNumber(
        getAttribute(sectionMetricsNode, 'data-fy-raw-count'),
        toNumber(context.fy_raw_count, 0)
      );
      var sectionRenderedCount = toNumber(getAttribute(sectionMetricsNode, 'data-fy-rendered-count'), 0);

      capture(posthogInstance, 'fy_section_status', {
        fy_status: 'rendered',
        fy_metafield_blank: context.fy_metafield_blank === true,
        fy_raw_count: sectionRawCount,
        fy_rendered_count: sectionRenderedCount,
        fy_set_id: sectionSetId,
        fy_version: toNumberOrEmpty(sectionVersionRaw !== '' ? sectionVersionRaw : context.fy_version),
        fy_generated_at: sectionGeneratedAt,
        fy_drop_missing_product_count: toNumber(getAttribute(sectionMetricsNode, 'data-fy-drop-missing-product-count'), 0),
        fy_drop_no_matching_variant_count: toNumber(
          getAttribute(sectionMetricsNode, 'data-fy-drop-no-matching-variant-count'),
          0
        ),
        fy_drop_no_available_variant_count: toNumber(
          getAttribute(sectionMetricsNode, 'data-fy-drop-no-available-variant-count'),
          0
        ),
        fy_page_instance_id: pageInstanceId,
        fy_section_id: sectionId,
        fy_not_rendered_reason: ''
      });

      var sectionImpressionFired = false;
      var sectionVisible = false;

      var sectionObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!runtime || runtime.id !== runId || sectionImpressionFired) {
              return;
            }

            if (entry.intersectionRatio >= VIEW_THRESHOLD) {
              sectionVisible = true;
              if (!runtime.sectionTimer) {
                runtime.sectionTimer = setTimeout(function () {
                  if (!runtime || runtime.id !== runId) {
                    return;
                  }

                  runtime.sectionTimer = null;
                  if (!sectionImpressionFired && sectionVisible) {
                    sectionImpressionFired = true;
                    capture(posthogInstance, 'fy_section_impression', {
                      fy_set_id: sectionSetId,
                      fy_version: toNumberOrEmpty(sectionVersionRaw !== '' ? sectionVersionRaw : context.fy_version),
                      fy_generated_at: sectionGeneratedAt,
                      fy_rendered_count: sectionRenderedCount,
                      fy_page_instance_id: pageInstanceId,
                      fy_section_id: sectionId,
                      fy_view_threshold: VIEW_THRESHOLD,
                      fy_visible_ms_threshold: VISIBLE_MS_THRESHOLD
                    });
                    sectionObserver.unobserve(sectionViewNode);
                  }
                }, VISIBLE_MS_THRESHOLD);
              }
              return;
            }

            sectionVisible = false;
            if (runtime.sectionTimer) {
              clearTimeout(runtime.sectionTimer);
              runtime.sectionTimer = null;
            }
          });
        },
        { threshold: [VIEW_THRESHOLD] }
      );

      runtime.sectionObserver = sectionObserver;
      sectionObserver.observe(sectionViewNode);

      var cardNodes = sectionViewNode.querySelectorAll('[data-fy-card="1"]');
      if (!cardNodes.length) {
        cardNodes = document.querySelectorAll('[data-fy-card="1"]');
      }
      if (!cardNodes.length) {
        return;
      }

      var firedCardDedupes = new Set();
      var cardVisible = new Map();

      function getCardDedupeKey(cardNode) {
        var fySetId = getAttribute(cardNode, 'data-fy-set-id');
        var fyProductHandle = getAttribute(cardNode, 'data-fy-product-handle');
        var fyVariantId = getAttribute(cardNode, 'data-fy-variant-id');
        var fyDisplayRank = getAttribute(cardNode, 'data-fy-display-rank');

        return (
          pageInstanceId +
          '|' +
          fySetId +
          '|' +
          fyProductHandle +
          '|' +
          fyVariantId +
          '|' +
          fyDisplayRank
        );
      }

      var cardObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!runtime || runtime.id !== runId) {
              return;
            }

            var cardNode = entry.target;
            var dedupeKey = getCardDedupeKey(cardNode);

            if (firedCardDedupes.has(dedupeKey)) {
              cardObserver.unobserve(cardNode);
              return;
            }

            if (entry.intersectionRatio >= VIEW_THRESHOLD) {
              cardVisible.set(dedupeKey, true);
              if (!runtime.cardTimers.has(dedupeKey)) {
                var timer = setTimeout(function () {
                  if (!runtime || runtime.id !== runId) {
                    return;
                  }

                  runtime.cardTimers.delete(dedupeKey);
                  if (!firedCardDedupes.has(dedupeKey) && cardVisible.get(dedupeKey) === true) {
                    firedCardDedupes.add(dedupeKey);

                    capture(posthogInstance, 'fy_card_impression', {
                      fy_set_id: getAttribute(cardNode, 'data-fy-set-id'),
                      fy_version: toNumberOrEmpty(getAttribute(cardNode, 'data-fy-version')),
                      fy_generated_at: getAttribute(cardNode, 'data-fy-generated-at'),
                      fy_product_handle: getAttribute(cardNode, 'data-fy-product-handle'),
                      fy_variant_id: getAttribute(cardNode, 'data-fy-variant-id'),
                      fy_model_rank: toNumber(getAttribute(cardNode, 'data-fy-model-rank'), 0),
                      fy_display_rank: toNumber(getAttribute(cardNode, 'data-fy-display-rank'), 0),
                      fy_page_instance_id: pageInstanceId,
                      fy_section_id: getAttribute(cardNode, 'data-fy-section-id'),
                      fy_view_threshold: VIEW_THRESHOLD,
                      fy_visible_ms_threshold: VISIBLE_MS_THRESHOLD
                    });

                    cardObserver.unobserve(cardNode);
                  }
                }, VISIBLE_MS_THRESHOLD);

                runtime.cardTimers.set(dedupeKey, timer);
              }
              return;
            }

            cardVisible.set(dedupeKey, false);
            var existingTimer = runtime.cardTimers.get(dedupeKey);
            if (existingTimer) {
              clearTimeout(existingTimer);
              runtime.cardTimers.delete(dedupeKey);
            }
          });
        },
        { threshold: [VIEW_THRESHOLD] }
      );

      runtime.cardObserver = cardObserver;
      cardNodes.forEach(function (cardNode) {
        cardObserver.observe(cardNode);
      });
    });
  }

  initializeForPageInstance();

  window.addEventListener('pageshow', function (event) {
    if (event && event.persisted === true) {
      initializeForPageInstance();
    }
  });

  window.addEventListener('pagehide', function () {
    cleanupRuntime();
  });
})();
